import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const root = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(${themeVariables.spacing.xxs});
  margin-bottom: var(${themeVariables.spacing.sm});
  min-height: 48px;
`;

export const prices = css`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: var(${themeVariables.colors.content.primary});
`;

export const rating = css`
  flex: 0 0 auto;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border: 1px solid var(${themeVariables.colors.stroke.default});
  border-radius: var(${themeVariables.borderRadius.md.desktop});
  background-color: var(${themeVariables.colors.surface.default});
  box-shadow: 0 0 4px 0
    color-mix(
      in srgb,
      var(${themeVariables.colors.content.default}) var(${themeVariables.tint.hover}),
      transparent
    );
  overflow: hidden;
  white-space: nowrap;
  text-align: right;
  font-family: var(${themeVariables.typography.body.fontFamily});

  > * {
    padding: var(${themeVariables.spacing.sm});
  }

  > * + * {
    border-left: 1px solid var(${themeVariables.colors.stroke.default});
  }
`;

export const preSaleInfo = css`
  display: flex;
  align-items: baseline;
  gap: var(${themeVariables.spacing.xs});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
`;

export const from = css`
  display: block;
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
`;

export const currentPrice = css`
  display: inline-block;
  margin: 0;
  color: var(${themeVariables.colors.content.primary});
  font-family: var(${themeVariables.typography.heading.fontFamily});
  font-size: var(${themeVariables.typography.heading.sizes.xs.fontSize});
  line-height: var(${themeVariables.typography.heading.sizes.xs.lineHeight});
`;

export const previousPrice = css`
  display: inline-block;
  margin: 0;
  color: var(${themeVariables.colors.content.secondary});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
`;

export const reviewsLink = css`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});

  small {
    font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  }
`;

export const badge = css`
  display: inline-flex;
  align-items: center;
  color: var(${themeVariables.colors.content.brand});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});

  svg {
    display: inline-block;
    margin-right: var(${themeVariables.spacing.xxs});
    vertical-align: text-bottom;
  }
`;

export const percentageOff = css`
  display: inline-block;
  white-space: nowrap;
  color: var(${themeVariables.colors.content.positive});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
`;

export const percentageOffRed = css`
  color: var(${themeVariables.colors.content.negative});
`;
